
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/aep/providers",
      function () {
        return require("private-next-pages/account/aep/providers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/aep/providers"])
      });
    }
  